import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import React from 'react'; import PropTypes from 'prop-types';
import Breadcrumbs from '../../components/Breadcrumbs';
import { selectors as profileSelectors } from '../../../modules/customer/profile';
import { actions as formActions } from '../../../modules/form';
import { customer } from '../../../modules';
import FormContainer from '../../components/FormContainer';
import FormConfirmationScreen from '../../../common/components/FormConfirmationScreen';
import UpdateCustomer from './UpdateCustomer';

const steps = [
    {
        stepNumber: 1,
        stepTitle: "",
        stepBody: <UpdateCustomer />,
        stepNextButtonText: "Update",
        isStepValidSelector: () => true,
    },
];

const formName = "UpdateCustomerForm"
const UpdateCustomerForm = ({ customerId, submitFormAction, clearFormDataAction, abortAction, data }) => {
    return (
        <FormContainer className="productCancellation"
            formName={formName}
            formTitle="Manage customer"
            stepsList={steps}
            confirmStepAction={() => submitFormAction(customerId, data)}
            onAbortHandler={abortAction}
            clearFormDataHandler={clearFormDataAction}
            showConfirmationScreen={true}
            confirmationScreenBody={<FormConfirmationScreen
                formName={formName}
                clearFormDataHandler={clearFormDataAction}
                redirectUrl={"/customer/" + customerId}
                isLoadingSelector={customer.profile.selectors.isLoadingUpdateForm}
                requestSuccessfulSelector={customer.profile.selectors.isSuccessfulUpdateForm}
            />}
        />
    );
};

const mapStateToProps = createStructuredSelector({
    customerId: profileSelectors.getCustomerID,
    data: customer.profile.selectors.getUpdateForm,
})

const mapDispatchToProps = (dispatch, state) => ({
    submitFormAction: (id, data) => dispatch(customer.profile.actions.updateCustomer(id, data)),
    clearFormDataAction: () => dispatch(customer.profile.actions.clearUpdateForm()),
    abortAction: formName => dispatch(formActions.resetForm(formName)).then(() => dispatch(customer.profile.actions.clearUpdateForm()))
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateCustomerForm);